<div class="container">
    <p>{{"AbpAccount::DisplayName:Version" | abpLocalization}}</p>
    <hr>
    <p>{{version()}}</p>
</div>
